import { triggerConstants } from './constants.ts';
import { type TriggerValues } from './types.ts';

export const getBidTrigger = (hasBid: boolean): TriggerValues => {
    if (hasBid) {
        return triggerConstants.TRIGGER_BID_INCREASE;
    }

    return triggerConstants.TRIGGER_BID_CLICK;
};
